import Template from "@/module/data/texts/textTemplateModule";

const jaMeta = {
  title: " | START | JP",
  description:
    "世の中に存在するUnconscious Beauty Bias (UBB)に目を向けてみよう。",
};

const enMeta = {
  title: " | START | EN",
  description:
    "Learn more about the Unconscious Beauty Bias (UBB) that exist in the world.",
};

const defaultMeta = {
  url: "/start/",
  ...Template.selectLanguage(jaMeta, enMeta),
};

export default defaultMeta;
